"use client";
import { useDisclosure, useEventListener } from "@chakra-ui/react";
import { type NextRouter } from "next/router";
import { useEffect } from "react";
import { type RscRouterParameters } from "./rsc-router-params";

//const mb = new MBClient()

export function usePlaceSearchModal({
  router,
  rsc = false,
}: RscRouterParameters) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Open or close the modal when pressing Cmd/Ctl + K
  useEventListener("keydown", (event) => {
    const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator?.platform);
    const hotkey = isMac ? "metaKey" : "ctrlKey";
    if (event?.key?.toLowerCase() === "k" && event[hotkey]) {
      event.preventDefault();
      isOpen ? onClose() : onOpen();
    }
  });

  // Close the modal
  useEffect(() => {
    // If not configured for Next 13's app directory
    if (!rsc) {
      (router as NextRouter)?.events?.on("routeChangeComplete", onClose);
    }
    return () => {
      if (!rsc) {
        (router as NextRouter)?.events?.off("routeChangeComplete", onClose);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
  };
}
